// ANGULAR
import { Injectable } from '@angular/core';
// SERVICES
import { GlobalService } from './global.service';
// OTHERS
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({ providedIn: "root" })
export class AlertService {
  constructor(private globalService: GlobalService) { }

  swalEditingNotEnabled(): void {
    Swal.fire({
      icon: "error",
      title: !!this.globalService.backupToPreview ? `Estás en modo visualización de Backup` : "El Oráculo no está en modo edición",
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      timer: 1500
    });
  }

  swalError(error: any): void {
    let message: string;

    if (typeof error === 'string') {
      message = error;
    } else {
      if (!!error?.title && !!error?.errors.aplicacion) {
        message = `${error.title} - ${error.errors.aplicacion}`;
      } else if (!!error?.title) {
        message = `${error.title}`;
      } else {
        message = '¡Error!'
      }
    }

    Swal.fire({
      icon: "error",
      title: "¡Error!",
      text: message,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      showDenyButton: false,
      showCancelButton: false
    });
  }

  showHtmlMessage(title: string, html: string, icon: 'success' | 'error' | 'warning' | 'info' | 'question', showIcon: boolean): void {
    Swal.fire({
      icon: showIcon ? icon : undefined,
      title: title,
      html: html,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      showDenyButton: false,
      showCancelButton: false,
    });
  }

  showBasicMessage(title: string, text: string, icon: 'success' | 'error' | 'warning' | 'info' | 'question', showIcon: boolean): void {
    Swal.fire({
      icon: showIcon ? icon : undefined,
      title: title,
      text: text,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      showDenyButton: false,
      showCancelButton: false
    });
  }

  showAutoCloseMessage(title: string, text: string, icon: 'success' | 'error' | 'warning' | 'info' | 'question', timer: number): void {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      timer: timer
    });
  }

  showMessageWithImage(title: string, text: string, imageUrl: string): void {
    Swal.fire({
      title: title,
      text: text,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      showDenyButton: false,
      showCancelButton: false,
      imageUrl: imageUrl,
      imageWidth: 200,
      imageHeight: 200
    });
  }

  async showConfirmAlert(title: string, text: string): Promise<SweetAlertResult<any>> {
    return await Swal.fire({
      icon: 'warning',
      title: title,
      text: text,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      confirmButtonText: 'Confirmar',
      showDenyButton: true,
      denyButtonColor: 'var(--false-color)',
      denyButtonText: 'Cancelar',
      showCancelButton: false,
      reverseButtons: true
    });
  }

  async showInputAlert(title: string, text: string, confirmButtonText: string = 'Confirmar'): Promise<SweetAlertResult<any>> {
    return await Swal.fire({
      title: title,
      text: text,
      showConfirmButton: true,
      confirmButtonColor: 'var(--primary-color)',
      confirmButtonText: confirmButtonText,
      showDenyButton: true,
      denyButtonColor: 'var(--false-color)',
      denyButtonText: 'Cancelar',
      showCancelButton: false,
      input: "text",
      inputAttributes: { autocapitalize: "off" },
      reverseButtons: true
    });
  }
}